import React, { Component } from "react";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import AppLayout from "../../layout/AppLayout";
import Dashboards from "./dashboards";
import Pages from "./pages";
import secondMenu from "./second-menu";
import blankPage from "./blank-page";
import Insights from "./insights";

class App extends Component {
  render() {
    const { match } = this.props;
    return (
      <AppLayout>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/welcome`} />
          <Route path={`${match.url}/dashboards`} component={Dashboards} />
          <Route path={`${match.url}/pages`} component={Pages} />
          <Route path={`${match.url}/second-menu`} component={secondMenu} />
          <Route path={`${match.url}/welcome`} component={blankPage} />
          <Route path={`${match.url}/insights`} component={Insights} />
          <Redirect to="/error" />
        </Switch>
      </AppLayout>
    );
  }
}
const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(App)
);
